import { Dispatch, useEffect, useState } from "react";
import { MdFlight } from "react-icons/md";
import { AiOutlineCaretDown, AiOutlineCaretUp } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import * as Actions from "../../store/actions";
import { Popover } from "@headlessui/react";

const TripType = ({ options, className = "w-full", name, dark = false }: any) => {
  const dispatch: Dispatch<any> = useDispatch();

  const tripType1 = useSelector((state: any) => state.form.tripType);
  const flightType1 = useSelector((state: any) => state.form.flightType);
  const [selectedOption, setSelectedOption] = useState<any>(options[0]);

  useEffect(() => {
    let x = options[0];
    if (name === "tripType" && tripType1) {
      x = tripType1;
    } else if (name === "flightType" && flightType1) {
      x = flightType1;
    }

    setSelectedOption(x);
  }, [flightType1, tripType1]);

  const selectOption = (option: any, close: any) => {
    setSelectedOption(option);
    if (name === "tripType") {
      dispatch(Actions.selectTripType(option));
    } else if (name === "flightType") {
      dispatch(Actions.selectFlightType(option));
    }
    close();
  };

  return (
    <div className="relative inline-block text-left">
      <Popover>
        {({ open, close }) => (
          <>
            <Popover.Button>
              <button
                type="button"
                className={
                  dark
                    ? "inline-flex capitalize gap-1 w-auto text-white font-medium items-center text-sm px-4 py-2  hover:bg-white/10 border-none  hover:rounded-md h-auto rounded-[4px]"
                    : "inline-flex capitalize gap-1 w-auto text-[#171717] font-medium items-center text-sm px-4 py-2  hover:bg-[#00000020] border-none  hover:rounded-md h-auto rounded-[4px]"
                }
                id="options-menu"
                aria-haspopup="listbox"
                aria-expanded="true"
              >
                <MdFlight className={dark ? "text-white" : "text-black"} />
                {selectedOption}
                {open ? <AiOutlineCaretUp /> : <AiOutlineCaretDown />}
              </button>
            </Popover.Button>
            <Popover.Panel>
              <div
                className={`origin-top-right absolute  mt-2 z-[2] rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 ${className}`}
              >
                <div
                  className="py-1 w-full text-left"
                  role="menu"
                  aria-orientation="vertical"
                  aria-labelledby="options-menu"
                >
                  {options.map((option: any, index: any) => (
                    <button
                      key={index}
                      onClick={() => selectOption(option, close)}
                      className={`text-left block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900 ${
                        selectOption === option && "bg-slate-600"
                      }`}
                      role="menuitem"
                    >
                      {option}
                    </button>
                  ))}
                </div>
              </div>
            </Popover.Panel>
          </>
        )}
      </Popover>
    </div>
  );
};

export default TripType;
